var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2858 16.8573C13.2445 16.8573 15.6429 14.4588 15.6429 11.5001C15.6429 8.54147 13.2445 6.143 10.2858 6.143C7.32712 6.143 4.92864 8.54147 4.92864 11.5001C4.92864 14.4588 7.32712 16.8573 10.2858 16.8573ZM10.2858 16.8573C5.55191 16.8573 1.71436 19.7355 1.71436 23.2859M10.2858 16.8573C15.0197 16.8573 18.8572 19.7355 18.8572 23.2859",
    stroke: "#1E2D66",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 1V7.85714M24 4.42857L17.1428 4.42857",
    stroke: "#1E2D66",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAccountIcon);
export default __webpack_public_path__ + "static/media/add_account_icon.a681c7939ca1c2654da7b1594daa4efd.svg";
export { ForwardRef as ReactComponent };